window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

$(theme.init);
